import { ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import jwt_decode from 'jwt-decode';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { userActions } from 'src/app/models/enums/user-permissions.enum';
import { FullUserData } from 'src/app/Modules/management/models/organization/fullUserData.model';
import { SettingsType } from 'src/app/Modules/settings/enums/settings-type.enum';
import { ManagementApiService } from 'src/app/services';
import { GlobalEmittersService } from 'src/app/services/global-emitters.service';
import { OrganizationDataService } from 'src/app/services/organization-data.service';
import { RouteServiceService } from 'src/app/services/route-service.service';
import { UrlService } from 'src/app/services/Url.service';
import { UserUtilityService } from 'src/app/services/user-utility.service';
import { WarningDialogComponent } from 'src/app/shared/info-dialogs/warning-dialog/warning-dialog.component';
import { KTUtil } from '../../../../../assets/js/components/util';
import KTLayoutHeaderMenu from '../../../../../assets/js/layout/base/header-topbar.js';
import KTLayoutHeader from '../../../../../assets/js/layout/base/header.js';
import { timer } from 'rxjs';
import { Notifications } from 'src/app/models/Notifications.model';
import { TermsConditionComponent } from 'src/app/shared/components/terms-condition/terms-condition.component';
import { UserSessions } from 'src/app/models/user-sessions-details';
import { ConfirmationDialogComponent } from 'src/app/shared/info-dialogs/confirmation-dialog/confirmation-dialog.component';
import { GenerateUniqueIdService } from 'src/app/services/generateuniqueid.service';
import { CustomAvatarService } from 'src/app/services/custom-avatar.service';
@Component({
    selector: 'app-home-custom-top-header',
    templateUrl: './home-custom-top-header.component.html',
    styleUrls: ['./home-custom-top-header.component.scss'],
    standalone: false,
})
export class HomeCustomTopHeaderComponent implements OnInit {
    @Output() isAdmin = new EventEmitter<string>();
    @ViewChild('ktHeaderMenu', { static: true }) ktHeaderMenu: ElementRef;
    ngUnsubscribe: Subject<any>;
    destroy$ = new Subject();

    headerMenuHTMLAttributes: any = {};
    isShown: boolean;
    isShownn: boolean;
    isNotificationDropdown: boolean;
    isUserDropdown: boolean;
    isNotificationShowing: any;
    flagLogin = true;
    isSystemAdmin = '';
    systemAdmin: boolean;
    isEditProfileEnabled: boolean = false;
    decodedToken: any;
    currentOrg: string;
    currentOrgId: string;
    currentInstance: string;
    isDropdownOpen = false;
    instanceNameSubscription: Subscription;
    hideInstaceLogout: boolean = false;
    hideOrgLogout: boolean = false;
    loggedInUserDetail: FullUserData;
    subscriptions: Subscription[] = [];
    profile: any;
    title = 'iDMS';
    accountName = '';
    loggedIn = false;
    canLogout = true;
    editProfileVisible: boolean;
    notificationsFullList: Notifications[] = [];
    notifications: Notifications[] = [];
    loginDisplay = false;
    oid: any;

    constructor(
        private router: Router,
        private authService: MsalService,
        private _managementApiService: ManagementApiService,
        private user_utility: UserUtilityService,
        private globalEmittersService: GlobalEmittersService,
        private routeServiceService: RouteServiceService,
        private elementRef: ElementRef,
        private organizationDataService: OrganizationDataService,
        private modalService: NgbModal,
        private urlService: UrlService,
        private ngxUiLoaderService: NgxUiLoaderService,
        private cd: ChangeDetectorRef,
        private genDeviceId: GenerateUniqueIdService,
        private userutility: UserUtilityService,
        private customAvatarService: CustomAvatarService
    ) {
        this.systemAdmin = false;
        this.ngUnsubscribe = new Subject();
        this.handleAllSubscriptions();
    }

    async ngOnInit(): Promise<void> {
        this.userutility.userSessionData.pipe(takeUntil(this.destroy$)).subscribe(async (res) => {
            if (res) {
                let currentUserId = this.authService.instance.getActiveAccount().idTokenClaims.oid;
                if (
                    (res.isActive == true && res.deviceId != localStorage.getItem('deviceId') && res.userId == currentUserId) ||
                    (res.isActive == false && localStorage.getItem('deviceId') && res.userId == currentUserId)
                ) {
                    //  this.logout();
                }
            }
        });

        this.checkUserSessionIsAcive();

        if (localStorage.getItem('selectedOrganizationName')) {
            this.currentOrg = localStorage.getItem('selectedOrganizationName');
            this.currentOrgId = localStorage.getItem('selectedOrgId');
        }

        if (localStorage.getItem('currentInstanceName')) {
            this.currentInstance = localStorage.getItem('currentInstanceName');
        }

        if (localStorage.getItem('msal.accessToken')) {
            this.getAccountName();
            if (!this.user_utility.userData) {
                //this.getAccountName();
                this.getFullUserData();
            }
            if (this.currentOrgId) {
                this.systemAdmin = await this.user_utility.checkUserPermissionDataAndRoute('Administration', userActions.View);
            }
        }

        const userData = this.user_utility.getUserData();
        if (userData?.isSysAdmin) {
            this.hideOrgLogout = true;
            this.hideInstaceLogout = true;
        } else {
            const organisations = userData?.organisations;
            const orgCount = organisations?.length;

            if (orgCount <= 1) {
                this.hideOrgLogout = orgCount !== 1;
                this.hideInstaceLogout = organisations[0]?.instances?.length <= 1 ? false : true;
            } else {
                this.hideOrgLogout = true;
                this.hideInstaceLogout = true;
                localStorage.setItem('orgCount', '0');
            }
        }

        this.isEditProfileEnabled = await this.user_utility.checkUserPermissionDataAndRoute('profile-personal-setting', userActions.View);

        this.globalEmittersService.currentOrgId.pipe(takeUntil(this.destroy$)).subscribe(async (orgId: string) => {
            if (orgId) {
                this.systemAdmin = await this.user_utility.checkUserPermissionDataAndRoute('Administration', userActions.View);
                this.currentOrgId = orgId;
            }
        });

        this.editProfileVisible = await this.user_utility.checkUserPermissionDataAndRoute('profile-email-notification-setting', userActions.View);
        this.getNotifications();
    }

    ngAfterViewInit(): void {
        if (this.ktHeaderMenu) {
            for (const key in this.headerMenuHTMLAttributes) {
                if (this.headerMenuHTMLAttributes.hasOwnProperty(key)) {
                    this.ktHeaderMenu.nativeElement.attributes[key] = this.headerMenuHTMLAttributes[key];
                }
            }
        }

        KTUtil.ready(() => {
            // Init Desktop & Mobile Headers
            KTLayoutHeader.init('kt_header', 'kt_header_mobile');
            // Init Header Menu
            KTLayoutHeaderMenu.init('kt_header_menu', 'kt_header_menu_wrapper');
        });
    }

    notfication() {
        this.isNotificationShowing = true;
        this.isShown = !this.isShown;
        if (this.isDropdownOpen) {
            this.isUserDropdown = false;
            this.isNotificationShowing = false;
        }
        this.isNotificationDropdown = !this.isNotificationDropdown;
    }

    user() {
        this.isShownn = !this.isShownn;
        if (this.isDropdownOpen) {
            this.isNotificationDropdown = false;
        }
        this.isUserDropdown = !this.isUserDropdown;
    }

    setLoginDisplay() {
        this.loginDisplay = this.authService.instance.getAllAccounts().length > 0;
    }

    isLoggedIn() {
        return this.authService.instance.getActiveAccount();
    }

    getAccountName() {
        this.accountName = this.authService.instance.getActiveAccount().idTokenClaims.name;
        //Case of demo user, name will be unknown, so construct the name using surname and firstname
        if (this.accountName === 'unknown') {
            if (this.authService.instance.getActiveAccount().idTokenClaims?.surname) {
                this.accountName =
                    this.authService.instance.getActiveAccount().idTokenClaims.surname +
                    ',' +
                    this.authService.instance.getActiveAccount().idTokenClaims.firstname;
            } else {
                this.accountName =
                    this.authService.instance.getActiveAccount().idTokenClaims.family_name +
                    ',' +
                    this.authService.instance.getActiveAccount().idTokenClaims.given_name;
            }
        }
        return this.accountName;
    }

    logout() {
        this.LogoutCurrentInstance();
        this.authService.logout();
        // this.globalEmittersService.initiateInterval.next(false); // * clear time
        localStorage.clear();
    }

    getDecodedAccessToken(token: string): any {
        try {
            return jwt_decode(token);
        } catch (Error) {
            return null;
        }
    }

    handleAllSubscriptions(): void {
        this.globalEmittersService.currentOrg.pipe(takeUntil(this.ngUnsubscribe)).subscribe((orgName: string) => {
            if (orgName) {
                this.currentOrg = orgName;
            }
        });

        this.instanceNameSubscription = this.globalEmittersService.currentInstanceName.pipe(takeUntil(this.destroy$)).subscribe((instanceName: string) => {
            if (instanceName) {
                this.currentInstance = instanceName;
            }
        });
    }

    @HostListener('document:click', ['$event.target'])
    public onClick(target) {
        const clickInside = this.elementRef.nativeElement.contains(target);
        if (this.isUserDropdown || this.isNotificationDropdown) {
            this.isDropdownOpen = true;
        } else {
            this.isDropdownOpen = false;
        }
        if (!clickInside) {
            this.isUserDropdown = false;
            this.isNotificationDropdown = false;
            this.isDropdownOpen = false;
        }
    }

    removeOrg() {
        localStorage.removeItem('selectedOrganizationName');
        localStorage.removeItem('selectedOrgId');
        this.currentOrg = null;
        this.currentOrgId = null;
        this.globalEmittersService.currentOrg.next(null);
        this.globalEmittersService.currentOrgId.next(null);
        this.removeInstance();
    }

    removeInstance() {
        this.currentInstance = null;
        localStorage.removeItem('currentInstanceName');
        localStorage.removeItem('currentInstanceId');
        localStorage.removeItem('currentInstanceTypeName');
        localStorage.removeItem('currentAssetType');
        localStorage.removeItem('selectedInstanceDetails');
        if (localStorage.getItem('activeTaggedItemData')) localStorage.removeItem('activeTaggedItemData');

        this.globalEmittersService.currentInstanceName.next(null);
        this.globalEmittersService.currentInstanceId.next(null);
        this.globalEmittersService.selectedCalcType.next(null); // * used for removing the  calc navigation route
    }

    getFullUserData() {
        this.ngxUiLoaderService.start();
        if (this.accountName.length > 0 && this.flagLogin) {
            let token = localStorage.getItem('msal.accessToken');
            this.decodedToken = this.getDecodedAccessToken(token);
            // this.globalEmittersService.initiateInterval.next(true);  // * initiate time interval
            this._managementApiService
                .getFullUserDetail(this.decodedToken.oid)
                .pipe(takeUntil(this.destroy$))
                .subscribe(
                    async (result) => {
                        if (result.success === true) {
                            //check license first
                            this.ngxUiLoaderService.stop();
                            this.loggedInUserDetail = result.response;
                            this.user_utility.setUserData(result.response);
                            this.globalEmittersService.profileDetails.next(result.response);
                            this.globalEmittersService.updateMenuVisisbility.next(true);
                            // if (this.checkLicenseValid()) {
                            if (this.user_utility.getUserData().isSysAdmin === true) {
                                this.isSystemAdmin = this.user_utility.getUserSecurityRoleName();
                                this.isAdmin.emit(this.isSystemAdmin);
                                //set security level
                                this.routeServiceService.enableRoute = this.isSystemAdmin ? true : false;
                                // this.router.navigate(["/home"]);
                            } else {
                                await this.setOrganization();
                                // this.setInstance();
                                this.handleInstance();
                                await this.setAdministrationLink();
                            }
                            // }
                        } else {
                            this.ngxUiLoaderService.stop();
                            this.user_utility.errorModelPopup(result.message);
                        }
                    },
                    () => {
                        this.ngxUiLoaderService.stop();
                    }
                );
            this.flagLogin = false;
        }
    }

    checkLicenseValid() {
        let licenseValid = this.user_utility.isLicenseValid();
        if (licenseValid) {
            return true;
        } else {
            //disable access to menu
            this.router.navigate(['/home']);
            this.globalEmittersService.isLicenseValid.next(false);
            //license is not valid
            let dialogRef = this.modalService.open(WarningDialogComponent, {
                size: 'sm',
                centered: true,
            });
            dialogRef.componentInstance.message = 'Your License has been expired!';
        }
    }

    async setOrganization() {
        let organizations = this.user_utility.getUserData().organisations;
        if (organizations !== undefined && Object.keys(organizations).length > 1) {
            this.router.navigate(['/management/organization']);
            this.globalEmittersService.hideOrgLogoutOption.next(false);
        } else {
            // let organization = this.user_utility.getUserData().organisation;
            let organization = this.user_utility.getUserData().organisation;
            if (organization?.enabled) {
                this.currentOrg = organization.name;
                this.globalEmittersService.currentOrg.next(organization.name);
                this.globalEmittersService.currentOrgId.next(organization.organisationId);
                this.organizationDataService.currentOrgId = organization.organisationId;
                this.organizationDataService.currentOrg = organization.name;
                localStorage.setItem('selectedOrganizationName', organization.name);
                localStorage.setItem('selectedOrganization', JSON.stringify(organization));
                localStorage.setItem('selectedOrgId', organization.organisationId);
                this.globalEmittersService.hideOrgLogoutOption.next(true);
                // removing the current instance stored in local storage because each organization has different instances
                // on selection on new organization previously selected have to removed
                if (localStorage.getItem('currentInstanceName')) {
                    this.globalEmittersService.currentInstanceName.next(null);
                }
                await this.setAdministrationLink();
            }
        }
    }

    // setInstance() {
    //     let organizations = this.user_utility.getUserData().organisations;
    //     if (this.user_utility.getUserData().hasOwnProperty('organisations') === false) {
    //         this.router.navigate(['/management/instance'], { queryParams: { organizationId: `${localStorage.getItem('selectedOrgId')}` } });
    //     } else if (this.user_utility.getUserData().hasOwnProperty('organisations') && Object.keys(organizations[0].instances).length > 1) {
    //         this.router.navigate(['/management/instance'], { queryParams: { organizationId: `${localStorage.getItem('selectedOrgId')}` } });
    //         this.globalEmittersService.hideInstanceLogoutOption.next(false);
    //     } else {
    //         this.globalEmittersService.currentInstanceName.next(organizations[0].instances[0].name);
    //         this.globalEmittersService.currentInstanceId.next(organizations[0].instances[0].instanceId);
    //         localStorage.setItem('currentInstanceName', organizations[0].instances[0].name);
    //         localStorage.setItem('currentInstanceId', organizations[0].instances[0].instanceId);
    //
    //         //setting instance type id
    //         this.globalEmittersService.currentInstanceTypeId.next(organizations[0].instances[0].instanceType.instanceTypeId);
    //         this.globalEmittersService.hideInstanceLogoutOption.next(true);
    //         //this.router.navigate(["/home"]);
    //     }
    // }

    async setAdministrationLink() {
        if (this.currentOrgId) {
            this.systemAdmin = await this.user_utility.checkUserPermissionDataAndRoute('Administration', userActions.View);
        }
    }

    // * handle instance stuff after user loggedIn
    handleInstance() {
        if (this.loggedInUserDetail) {
            if (this.loggedInUserDetail?.organisations !== null && this.loggedInUserDetail?.organisations !== undefined) {
                if (this.loggedInUserDetail?.organisations.length <= 1) {
                    if (this.loggedInUserDetail.organisations[0]?.instances.length > 1) {
                        // * when user have assigned multiple instances
                        this.router.navigate(['/management/instance'], {
                            queryParams: {
                                organizationId: `${localStorage.getItem('selectedOrgId')}`,
                            },
                        });
                        this.globalEmittersService.hideInstanceLogoutOption.next(false);
                    } else if (this.loggedInUserDetail?.organisations[0]?.instances.length == 1) {
                        if (this.loggedInUserDetail.organisations[0].instances[0]?.enabled) {
                            // * when user have only one instance assigned directly selecting that instance for user
                            this.globalEmittersService.currentLicenseInstanceTypeIndex.next(this.loggedInUserDetail.license.instanceTypeIndex);
                            // localStorage.setItem('currentInstanceName', this.loggedInUserDetail.organisations[0].instances[0].name);
                            // localStorage.setItem('currentInstanceId', this.loggedInUserDetail.organisations[0].instances[0].instanceId);
                            if (this.loggedInUserDetail.organisations[0]?.instances[0]?.instanceId)
                                this.setSessionInstance(this.loggedInUserDetail.organisations[0].instances[0].instanceId);
                        }
                    }
                } else {
                    this.globalEmittersService.hideInstanceLogoutOption.next(false);
                    this.router.navigate(['/home']);
                }
            } else if (this.loggedInUserDetail?.license && this.loggedInUserDetail?.license.instanceTypeIndex == 4) {
                if (!this.loggedInUserDetail?.organisation) {
                    localStorage.setItem('IsNoOrgCDMSUser', 'true');
                }

                this.router.navigate(['/home']);
            }
            // else {
            //     // TODO Display the error popUp
            //     this.router.navigate(['/home']);
            //     this.user_utility.errorModelPopup('You are not added to any instace, contact admin to add you in instance!');
            // }
        }
    }

    async setSessionInstance(instanceId: string) {
        let instanceResponse = null;
        if (this.loggedInUserDetail.isSysAdmin) {
            instanceResponse = await this._managementApiService.getInstanceById(instanceId).toPromise();
            if (instanceResponse.success === true) {
                if (instanceResponse?.response) {
                    let instanceDetails = instanceResponse.response;
                    localStorage.setItem('currentInstanceName', instanceDetails?.name);
                    localStorage.setItem('currentInstanceId', instanceDetails?.instanceId);
                    localStorage.setItem('selectedInstanceDetails', JSON.stringify(instanceDetails));
                    localStorage.setItem('currentInstanceTypeName', instanceDetails?.instanceType?.name);
                    localStorage.setItem('currentAssetType', instanceDetails?.instanceAssetType?.name);
                    this.globalEmittersService.currentInstanceName.next(this.loggedInUserDetail?.organisations[0]?.instances[0]?.name);
                    this.globalEmittersService.currentInstanceId.next(this.loggedInUserDetail?.organisations[0]?.instances[0]?.instanceId);
                    this.globalEmittersService.hideInstanceLogoutOption.next(true);
                    this.router.navigate(['/home']);
                }
            }
        } else {
            instanceResponse = await this._managementApiService.getInstanceByOrgId(localStorage.getItem('selectedOrgId')).toPromise();
            if (instanceResponse.success === true) {
                if (instanceResponse?.response) {
                    let instanceDetails = instanceResponse.response.find((m) => m.instanceId == instanceId);
                    localStorage.setItem('currentInstanceName', instanceDetails?.name);
                    localStorage.setItem('currentInstanceId', instanceDetails?.instanceId);
                    localStorage.setItem('selectedInstanceDetails', JSON.stringify(instanceDetails));
                    localStorage.setItem('currentInstanceTypeName', instanceDetails?.instanceType?.name);
                    localStorage.setItem('currentAssetType', instanceDetails?.instanceAssetType?.name);
                    this.globalEmittersService.currentInstanceName.next(this.loggedInUserDetail?.organisations[0]?.instances[0]?.name);
                    this.globalEmittersService.currentInstanceId.next(this.loggedInUserDetail?.organisations[0]?.instances[0]?.instanceId);
                    this.globalEmittersService.hideInstanceLogoutOption.next(true);
                    this.router.navigate(['/home']);
                }
            }
        }
    }

    // * setting navigation handler
    async navigateToSetting() {
        const route = this.urlService.currentUrl.split('/')[1];
        let navigateTo = '/settings/profile';

        switch (route) {
            case SettingsType.Home:
            case SettingsType.Management:
                if (await this.checkPermission('general')) {
                    navigateTo = '/settings/general';
                }
                break;
            case SettingsType.Informate:
                if (await this.checkPermission('view-informate-settings')) {
                    navigateTo = '/settings/informate';
                }
                break;
            case SettingsType.Idms:
                if (await this.checkPermission('view-idms-settings')) {
                    navigateTo = '/settings/idms';
                }
                break;
            case SettingsType.Cdms:
                if (await this.checkPermission('cdms-settings')) {
                    navigateTo = '/settings/cdms-settings';
                }
                break;
        }

        this.router.navigate([navigateTo]);
    }

    // * helper for checking access levels
    async checkPermission(route: string): Promise<boolean> {
        return await this.user_utility.checkUserPermissionDataAndRoute(route, userActions.View);
    }

    //Getting notifications

    removeHTMLTags(htmlString) {
        return htmlString.replace(/<[^>]*>/g, '');
    }

    getNotifications() {
        if (this.accountName) {
            timer(0, 300000).subscribe(async () => {
                let temp = await this._managementApiService.getNotifications().toPromise();
                if (temp.success === true) {
                    temp.response.forEach((n) => {
                        n.message = this.removeHTMLTags(n.message);
                    });
                    this.notificationsFullList = temp.response;
                    this.cd.markForCheck();
                    this.notifications = temp.response.slice(0, 5);
                    this.cd.markForCheck();
                } else {
                    this.user_utility.errorModelPopup(temp.message);
                }
            });
        }
    }

    open(content) {
        this.modalService.open(content, {
            ariaLabelledBy: 'modal-basic-title',
            size: 'xl',
            // backdrop: 'static',
            windowClass: 'dialog_modal_class',
            keyboard: false,
        });
    }

    //remove or notify notifications
    NotifyNotification(noti: Notifications) {
        let resultNoti: any = {};
        resultNoti.userNotificationId = noti.notifiers[0].userNotificationId;
        resultNoti.actioned = true;
        let result = [];
        result.push(resultNoti);
        this.updateNotification(result);
        // let Errmessage;
        // let successMessage;
        // this.translocoService.selectTranslateObject('TOAST_MESSAGE.NOTIFICATION_SUCCESS').subscribe((res) => {
        //     successMessage = res;
        // });
        // this.translocoService.selectTranslateObject('TOAST_MESSAGE.NOTIFICATION_ERROR').subscribe((res) => {
        //     Errmessage = res;
        // });
    }

    async updateNotification(payload) {
        let res = await this._managementApiService.updateNotification(payload).toPromise();

        if (res.success === true) {
            payload = [];
            this.getNotifications();
        } else {
        }
    }

    // * handle notification Click
    notificationClick(notification: Notification) {
        this.isNotificationDropdown = false;
        let dialogRef = this.modalService.open(TermsConditionComponent, {
            size: 'xl',
            keyboard: false,
            windowClass: 'custom-modal-style',
            backdrop: false,
        });
        dialogRef.componentInstance.notification = notification;
        dialogRef.result
            .then(() => {
                this.getNotifications();
                this.cd.markForCheck();
            })
            .catch((e) => {
                console.warn(e);
            });
    }

    async clearAllNotification() {
        let payload: any = [];
        this.notificationsFullList.forEach((x) => {
            let obj: any = {};
            (obj.userNotificationId = x.notifiers[0].userNotificationId), (obj.actioned = true);
            payload.push(obj);
        });

        await this.updateNotification(payload);
        if (this.isNotificationDropdown) this.isNotificationDropdown = false;
        if (this.modalService.activeInstances) {
            this.modalService.dismissAll();
        }
    }
    // * check text oveflow
    checkIsTextOverflow(hoverProperty: string): boolean {
        const element = document.getElementById(hoverProperty);
        if (element) {
            return element.scrollWidth > element.offsetWidth;
        }
        return false;
    }

    isUserSignedIn() {
        if (this.authService.instance.getActiveAccount().idTokenClaims.oid) {
            return true;
        }
        return false;
    }

    isCdmsModule(): boolean {
        return this.router.url.includes('cdms/');
    }

    calculateDiff(data) {
        let date = new Date(data);
        let currentDate = new Date();

        let days = Math.floor(
            (Date.UTC(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate()) -
                Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())) /
                (1000 * 60 * 60 * 24)
        );

        return days;
    }

    checkUserSessionIsAcive() {
        const usercheck = this.getUserSessionData();
        this._managementApiService
            .checkUserSessionIsActive(usercheck)
            .pipe(takeUntil(this.destroy$))
            .subscribe(
                (res) => {
                    const dayDiff = this.calculateDiff(res.response.loginTime);
                    if (res && res.response && res.response.isActive == true && res.response.deviceId != usercheck.deviceId && dayDiff < 1) {
                        let dialogRef = this.modalService.open(ConfirmationDialogComponent, {
                            size: 'sm',
                            backdrop: 'static',
                            keyboard: false,
                        });
                        dialogRef.componentInstance.modalMessage = 'UserId logged in already .Are you sure you want Logout from  other instance?';
                        dialogRef.result
                            .then((result) => {
                                if (result === true) {
                                    this.changeStatusToLogOutOtherInstance(true);
                                } else {
                                    this.logout();
                                }
                            })
                            .catch((e) => {
                                console.warn(e);
                            });
                    } else if (
                        res &&
                        res.response &&
                        res.response.isActive == false &&
                        res.response.userId != usercheck.userId &&
                        usercheck.deviceId != localStorage.getItem('deviceId')
                    ) {
                        this.logout();
                    } else if (res && res.response && res.response.isActive == false) {
                        const user = this.getUserSessionData(true);
                        this.saveUserSessiondata(user);
                    } else if ((res && res.response == undefined) || dayDiff >= 1) {
                        const user1 = this.getUserSessionData(true);
                        this.saveUserSessiondata(user1);
                    }
                },

                // (error:HttpErrorResponse) => {
                //     console.log(error);

                //     let errorPayload = JSON.parse(error.message);
                //     console.log(errorPayload);
                //     //ToDo: apply your handling logic e.g.://console.log(errorPayload[0].descriptionconsole.log(error.error);
                // }
                () => {
                    // let errorPayload = JSON.parse(err.message);
                    // console.log(errorPayload);
                    this.ngxUiLoaderService.stop();
                }
            );
    }

    checkForLogoutConcurrentUser() {
        const user = this.getUserSessionData();
        this._managementApiService
            .checkUserSessionIsActive(user)
            .pipe(takeUntil(this.destroy$))
            .subscribe(
                (res) => {
                    if ((res.response.isActive == true && res.response.deviceId != user.deviceId) || (res.response.isActive == false && user.deviceId)) {
                        this.logout();
                    }
                },
                (err) => {
                    let errorPayload = JSON.parse(err.message);
                    this.ngxUiLoaderService.stop();
                }
            );
    }

    changeStatusToLogOutOtherInstance(isSaveCurrentUserData: boolean) {
        const userForLogout = this.getUserSessionData(true);
        this._managementApiService
            .changeStatusForLogOut(userForLogout)
            .pipe(takeUntil(this.destroy$))
            .subscribe(
                (res) => {
                    if (res) {
                        if (isSaveCurrentUserData) {
                            localStorage.setItem('isActiveUser', 'true');
                            const currentUser = this.getUserSessionData(true);
                            this.saveUserSessiondata(currentUser);
                        }
                    } else {
                        this.user_utility.errorModelPopup(res);
                    }
                },
                () => {
                    this.ngxUiLoaderService.stop();
                }
            );
    }

    saveUserSessiondata(user: UserSessions) {
        this._managementApiService
            .addUsersessionDetails(user)
            .pipe(takeUntil(this.destroy$))
            .subscribe(
                (res) => {
                    if (res) {
                        localStorage.setItem('isActiveUser', user.isActive ? 'true' : 'false');
                    } else {
                        this.user_utility.errorModelPopup(res);
                    }
                },
                () => {
                    this.ngxUiLoaderService.stop();
                }
            );
    }

    getDeviceId() {
        let deviceId = localStorage.getItem('deviceId');
        if (!deviceId) {
            deviceId = this.genDeviceId.generateUUIDV4();
            localStorage.setItem('deviceId', deviceId);
        }
        return deviceId;
    }

    getUserSessionData(isActive: boolean = false) {
        let user: UserSessions = new UserSessions();
        user.userId = this.authService.instance.getActiveAccount().idTokenClaims.oid;
        user.isActive = isActive;
        user.loginTime = new Date();
        user.deviceId = this.getDeviceId();
        user.editedBy = this.authService.instance.getActiveAccount().idTokenClaims.oid;
        user.editedDate = new Date();
        return user;
    }

    LogoutCurrentInstance() {
        const userForLogout = this.getUserSessionData();
        this._managementApiService
            .logoutCurrentUser(userForLogout)
            .pipe(takeUntil(this.destroy$))
            .subscribe(
                (res) => {
                    if (res) {
                    } else {
                        this.user_utility.errorModelPopup(res);
                    }
                },
                () => {
                    this.ngxUiLoaderService.stop();
                }
            );
    }

    contactLinkClick() {
        this.globalEmittersService.contactLinkClick.next(true);
        this.router.navigate(['/contact-us']);
    }

    openNotificationSettings() {
        this.modalService.dismissAll();
        this.router.navigate(['/settings/profile'], { queryParams: { index: 1 } });
    }

    closeModel() {
        this.modalService.dismissAll();
    }

    getInitials(name: string): string {
        if (!name) return '';
        return this.customAvatarService.getShortInitials(name);
    }
    ngOnDestroy(): void {
        this.subscriptions.forEach((subscription) => subscription.unsubscribe());
        this.ngUnsubscribe.next(null);
        this.ngUnsubscribe.complete();
        this.instanceNameSubscription.unsubscribe();
        this.destroy$.next(null);
        this.destroy$.complete();
    }
}
